/** Home — the most recently updated notes. */

import { fetchRecentNotes } from "../api/notes";
import type { NoteSummary } from "../api/types";
import { noteList } from "../components/noteList";
import { pageHeader } from "../components/pageHeader";
import { emptyState } from "../components/states";
import { runAsyncView } from "../lib/asyncView";
import { el } from "../lib/dom";
import { newNotePath, searchPath } from "../router/paths";
import type { PageView } from "../router/router";

const RECENT_LIMIT = 25;

export function homePage(): PageView {
  const results = el("div", { className: "panel" });

  const view = runAsyncView<readonly NoteSummary[]>({
    container: results,
    loadingLabel: "Loading recent notes…",
    load: (signal) => fetchRecentNotes(RECENT_LIMIT, signal),
    render: (notes) =>
      notes.length === 0
        ? emptyState("No notes yet", "Create your first note to get started.")
        : noteList(notes),
  });

  const element = el("section", {
    className: "page page--home",
    children: [
      pageHeader({
        title: "Recent notes",
        subtitle: "The notes you touched most recently.",
        actions: [
          el("a", { className: "button button--secondary", attrs: { href: searchPath() }, text: "Search" }),
          el("a", { className: "button button--primary", attrs: { href: newNotePath() }, text: "New note" }),
        ],
      }),
      results,
    ],
  });

  return { element, dispose: view.dispose };
}
